// extracted by mini-css-extract-plugin
export default {"externalClientBadgeLabel":"L7kfb61b"};